export const eventPackagesData = [
  {
    id: 1,
    name: 'basic wedding package',
    price: 26999,
    originalPrice: 32000,
    duration: 'Reception | Muhurtham',
    fullDescription: 'Ideal for wedding receptions and muhurtham ceremonies. This package focuses on capturing traditional moments with high-quality photos and videos, along with professional editing to preserve your special day beautifully.',
    features: [
      'Traditional Photos',
      'Traditional Videos',
      'Traditional Edited Video'
    ],
    image: '/assets/package_images/postwedding.jpg',
    color: '#667eea'
  },
  {
    
      id: 2,
      name: 'Premium Wedding Coverage',
      price: 69999,
      originalPrice: 74999,
      duration: 'Reception | Muhurtham',
      fullDescription: 'A comprehensive wedding package designed to capture every special moment with a blend of traditional and cinematic styles. This package includes professional photography, videography, highlight edits, and candid captures to create a complete and memorable wedding story.',
      features: [
        'Traditional Photos',
        'Traditional Videos + Edited',
        'Highlights Video Editing',
        'Cinematic Video',
        'Candid Photos + 30 Edited Pics'
    ],
    image: '/assets/package_images/babyshower.jpg',
    color: '#f093fb'
  },
  {
    id: 3,
    name: 'Advanced Wedding Story Package',
    price: 99999,
    originalPrice: 104999,
    duration: 'Pre-Wedding | Reception | Muhurtham',
    fullDescription: 'A well-balanced wedding package combining pre-wedding creativity with full event coverage. Designed for couples who want both traditional and cinematic storytelling, this package includes curated edits, candid captures, and highlight videos to preserve every meaningful moment.',
    features: [
      'Pre-Wedding (1 Day) + 1 Song Editing',
      'Traditional Photos',
      'Traditional Videos + Edited',
      'Candid Photos + 30 Edited Pics',
      'Highlights Video Editing',
      'Cinematic Videos'
    ],
    image: '/assets/package_images/prewedding.jpg',
    color: '#f5576c'
  },
  {
    id: 4,
    name: 'Elite Wedding Experience',
    price: 169999,
    originalPrice: 174999,
    duration: 'Pre-Wedding | Reception | Muhurtham',
    fullDescription: 'A premium all-inclusive wedding package crafted for couples who want a complete cinematic and traditional experience. From pre-wedding shoots to full event coverage, this package delivers high-end visuals, drone shots, and creative edits to tell your wedding story in the most memorable way.',
    features: [
      'Pre-Wedding (2 Days) + 1 Song Editing',
      '2-Cam Mixing (Reception Only)',
      'Cinematic Videos + Editing',
      'Candid Photos + 40 Edited Pics',
      'Traditional Photos',
      'Traditional Videos + Editing',
      'Drone Coverage',
      'LED Wall (Reception Only)',
      '2 Reels'
    ],
    image: '/assets/package_images/wedding.jpg',
    color: '#4facfe'
  },
  {
    id: 5,
    name: 'Signature Wedding Cinematic Package',
    price: 209999,
    originalPrice: null,
    duration: 'Pre-Wedding | Reception | Muhurtham',
    fullDescription: 'A high-end wedding package designed for couples who want a complete cinematic and premium experience. This package includes pre-wedding storytelling, multi-camera coverage, drone visuals, LED wall setup, and professionally edited photos and videos to create a grand and unforgettable wedding narrative.',
    features: [
      'Pre-Wedding + 1 Song Editing',
      '2-Cam Mixing Unit (Reception & Muhurtham)',
      'Traditional Photos',
      'Traditional Videos + Editing',
      'Candid Photos + 40 Edited Pics',
      'Cinematic Videos + Editing',
      'Drone Coverage',
      '2 Reels',
      '2 Days LED Wall'
    ],
    image: '/assets/package_images/movieshooting.jpg',
    color: '#fa709a'
  },
  {
    id: 6,
    name: 'Luxury Wedding Platinum Experience',
    price: 239999,
    originalPrice: 269999,
    duration: 'Reception | Muhurtham',
    fullDescription: 'A luxury wedding package crafted for grand celebrations, combining cinematic storytelling, multi-camera production, live streaming, and premium deliverables. This package ensures every moment is captured, edited, and presented with exceptional quality and elegance.',
    features: [
      'Pre-Wedding + 1 Song Editing',
      '3-Cam Mixing Unit (Reception & Muhurtham)',
      'Cinematic Videos + Editing',
      'Candid Photos + 50 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage',
      '2 Reels',
      '2 Days LED Wall',
      '50 Pages Album',
      'Live YouTube & Facebook Streaming (Reception)'
    ],
    image: '/assets/package_images/ads.png',
    color: '#667eea'
  },
  {
    id: 7,
    name: 'Ultimate Wedding Experience',
    price: 279999,
    originalPrice: 319999,
    duration: 'Reception | Muhurtham',
    fullDescription: 'The ultimate all-inclusive wedding package designed for grand, royal celebrations. This package delivers a complete cinematic production with multi-camera coverage, live streaming, premium album design, and advanced visual storytelling to capture every moment in the most luxurious way possible.',
    features: [
      '2-Cam Mixing Unit (Reception & Muhurtham)',
      'Traditional Photos',
      'Traditional Videos + Editing',
      'Candid Photos + 40 Edited Pics',
      'Cinematic Videos + Editing',
      'Pre-Wedding + 1 Song Editing',
      'Drone Coverage',
      '2 Reels',
      '2 Days LED Wall',
      'Live YouTube & Facebook Streaming (Reception & Muhurtham)',
      '100 Pages Album'
    ],
    image: '/assets/package_images/ads.png',
    color: '#667eea'
  },
  

];

export const houseWarmingPackagesData = [
  {
    id: 8,
    name: 'Essential Housewarming Coverage',
    price: 28999,
    originalPrice: 32999,
    duration: 'House Warming Ceremony',
    fullDescription: 'A perfect starter package for housewarming ceremonies, capturing all traditional rituals with professional photography and videography. Designed to preserve your special moments with clean edits and social-ready reels.',
    features: [
      'Traditional Photos',
      'Traditional Videos + Editing',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  },
  {
    id: 2,
    name: 'Premium Housewarming Experience',
    price: 79999,
    originalPrice: 94999,
    duration: 'House Warming Ceremony',
    fullDescription: 'A premium housewarming package designed to capture your special occasion with a cinematic touch. This package blends candid photography, traditional coverage, and professionally edited videos to create a complete and memorable celebration story.',
    features: [
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 20 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  },
  {
    id: 3,
    name: 'Elite Housewarming Celebration Package',
    price: 119999,
    originalPrice: 139999,
    duration: 'House Warming Ceremony',
    fullDescription: 'An elite housewarming package designed for grand celebrations, combining cinematic storytelling, drone coverage, and live streaming. This package ensures every ritual and moment is captured beautifully with high-quality visuals and professional editing.',
    features: [
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 40 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage (1 Day)',
      'Live YouTube & Facebook Streaming (1 Day)',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  },{
    id: 4,
    name: 'Luxury Housewarming Grand Experience',
    price: 149999,
    originalPrice: 174999,
    duration: 'House Warming Ceremony',
    fullDescription: 'The ultimate housewarming package designed for grand and memorable celebrations. This package offers a complete cinematic experience with drone coverage, live streaming, LED wall setup, and high-quality photo and video production to capture every ritual in stunning detail.',
    features: [
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 40 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage (1 Day)',
      'Live YouTube & Facebook Streaming (1 Day)',
      'LED Wall (1 Day)',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  }
];

export const birthdayPackagesData = [
  {
    id: 1,
    name: 'Essential Birthday Celebration Coverage',
    price: 19999,
    originalPrice: 24999,
    duration: 'Birthday Event',
    fullDescription: 'A perfect package for birthday celebrations, capturing all the joyful moments with professional photography and videography. Ideal for small to medium gatherings, ensuring every special memory is preserved beautifully.',
    features: [
      'Traditional Videos + Editing',
      'Traditional Photos'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  },{
    id: 2,
    name: 'Luxury Birthday Celebration Experience',
    price: 109999,
    originalPrice: 129999,
    duration: 'Birthday Event',
    fullDescription: 'A premium birthday celebration package designed for grand and vibrant events. This package combines cinematic storytelling, multi-camera production, drone coverage, and creative visuals to capture every joyful moment in a stunning and memorable way.',
    features: [
      '2 Cam Mixing Unit',
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 40 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage',
      'LED Setup',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  }
];
export const babyShootPackagesData = [
  {
    id: 1,
    name: 'Luxury Baby Photoshoot Experience',
    price: 109999,
    originalPrice: 129999,
    duration: 'Baby Photoshoot',
    fullDescription: 'A premium baby photoshoot package designed to capture adorable and memorable moments with cinematic visuals and creative storytelling. This package includes professional photography, videography, and premium add-ons to create a beautiful keepsake of your baby’s special moments.',
    features: [
      '2 Cam Mixing Unit',
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 40 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage',
      'LED Setup',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  }
];
export const halfSareePackagesData = [
  {
    id: 1,
    name: 'Luxury Half Saree Ceremony Experience',
    price: 109999,
    originalPrice: 129999,
    duration: 'Half Saree Ceremony',
    fullDescription: 'A premium package designed to beautifully capture the traditional Half Saree ceremony with cinematic storytelling and elegant visuals. This package combines candid photography, traditional coverage, and creative video production to preserve every special moment of this important cultural celebration.',
    features: [
      '2 Cam Mixing Unit',
      'Cinematic Videos + Editing (5 Min)',
      'Candid Photos + 40 Edited Pics',
      'Traditional Videos + Editing',
      'Traditional Photos',
      'Drone Coverage',
      'LED Setup',
      '2 Reels'
    ],
     image: '/assets/package_images/ads.png',
    color: '#667eea'
  }
];